import React from "react";
import { Controller } from "react-hook-form";
import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";

const Select = ({
  name,
  control,
  label,
  options,
  isRequired,
  onChange,
  preValue,
  disabled,
  optionLabel,
  optionValue,
  className,
  itemTemplate,
  valueTemplate,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: isRequired ? "Campo obrigatório" : false }}
      render={({ field, fieldState }) => (
        <>
          <label htmlFor={field.name}></label>
          <FloatLabel className="w-100">
            <Dropdown
              showClear
              filter
              itemTemplate={itemTemplate}
              valueTemplate={valueTemplate}
              className={`${className} ${
                fieldState.error ? "is-invalid" : ""
              } w-100`}
              optionLabel={optionLabel}
              optionValue={optionValue}
              id={field.name}
              disabled={disabled}
              value={
                preValue && field.value === undefined ? preValue : field.value
              }
              options={
                options ?? options?.map((option) => ({
                  ...option, // Mantém as propriedades existentes
                  disabled: option.isDisabled ?? false,
                })) ?? []
              }
              emptyFilterMessage="Nenhuma informação encontrada."
              emptyMessage="Nenhuma informação encontrada."
              onChange={(e) => {
                field.onChange(e.value);
                onChange && onChange(e.value); // Repasse do evento onChange se fornecido
              }}
            />
            <label htmlFor={field.name}>{label}</label>
          </FloatLabel>
          {fieldState.error && (
            <span className="p-error">{fieldState.error.message}</span>
          )}
        </>
      )}
    />
  );
};

export default Select;
